import React from "react";
import vocalImage from "../img/микрофон.jpg";
import saleImage from "../img/культуры.jpg";
import cultureImage from "../img/Корп-культура.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

export const Education = () => {
  const education = [
    {
      title: "Культура вокально-речевой выразительности",
      img: vocalImage,
      category:
        "Это комплексное обучение, охватывающее техники выразительной речи и вокала, а также сценические навыки, что позволяет людям всех возрастов, профессий овладеть искусством общения и исполнения.",
    },
    {
      title: "Культура продаж и взаимообмена",
      img: saleImage,
      category:
        "Для всех желающих любого уровня подготовки. На курсе ученики изучают применение научно-творческого подхода в процессе взаимообмена, продаж, продвижения через использование лаконичной матрицы действий.",
    },
    {
      title: "Корпоративная культура",
      img: cultureImage,
      category:
        "В рамках курса мы работаем с организациями различного характера. Выявляем отличительные особенности компаний, целостность подачи, восприятия их образа сотрудниками, клиентами, уровень общей культуры, этики и эстетики, способы взаимодействия с персоналом. Оптимизируем корпоративные процессы, формируя привлекательный имидж, способствующий успеху, гармоничному взаимодействию.",
    },
  ];

  return (
    <section id="portfolio" className="about-section">
      <div className="container">
        <div className="section-title text-center">
          <h2>Образование</h2>
          <p className="education-intro">
            <strong>Наши курсы</strong> ориентированы на <em>всех желающих</em>, независимо от уровня подготовки.  
            Они охватывают <strong>разнообразные аспекты культурной и социальной жизни</strong>.
            <br /><br />
            <strong>Социокультурные</strong> и <strong>просветительные</strong> курсы с использованием авторских методик. 
            <br/>
            <strong>Творческий подход</strong> и <strong>саморазвитие</strong> в области психологической, вокально- речевой, сценической, корпоративной культуры, взаимообмена, продвижения и продаж
            <br /><br />
            Мы используем <strong>авторские методики</strong> и <strong>научно обоснованные подходы</strong>, 
            что позволяет каждому участнику не только <em>получить новые знания</em>, но и  <strong>развить практические навыки</strong>, полезные как в <em>личной</em>, так и в <em>профессиональной</em> сфере.
          </p>
        </div>

        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          style={{ padding: "20px 0", height: "720px" }}
          breakpoints={{
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {education.map((edu, index) => (
            <SwiperSlide key={index}>
              <div className="card-wrapper fade-in-up" style={{ cursor: "default" }}>
                <div className="card-education">
                  <img src={edu.img} alt={edu.title} className="card-image" />
                  <div className="card-content">
                    <h3 className="card-title">{edu.title}</h3>
                    <div className="card-description">{edu.category}</div>
                    <a href="#contact" className="card-button-education page-scroll">
                      Оставить заявку
                    </a>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="education-extra-text">
          <p>
            <strong>Каждый курс структурирован на три уровня работы: экспрессивный, интенсивный и экстенсивный,</strong> что позволяет адаптировать обучение под конкретные потребности, цели участников. Особенности форматов:
          </p>
          <ul>
            <li>
              <strong>Экспрессив.</strong> Включает введение, тестирование, пробу или срочную подготовку — 1 консультация;
            </li>
            <li>
              <strong>Интенсив.</strong> Может состоять от 1 до 20 консультаций, в зависимости от темы курса и запросов клиента;
            </li>
            <li>
              <strong>Экстенсив.</strong> Количество встреч определяется по согласованию предложений консультанта, потребностями клиента.
            </li>
          </ul>
          <p>
            Наши программы направлены на передачу знаний, практическое применение полученных навыков, что делает обучение эффективным, результативным.
          </p>
          <p>
            Приглашаем присоединиться к нашим курсам, открыть новые горизонты в сфере коммуникации и самовыражения!
          </p>
        </div>
      </div>
    </section>
  );
};
